import { render } from "./CustomAlert.vue?vue&type=template&id=d8a90382"
import script from "./CustomAlert.vue?vue&type=script&lang=js"
export * from "./CustomAlert.vue?vue&type=script&lang=js"

import "./CustomAlert.vue?vue&type=style&index=0&id=d8a90382&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__